import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  Box,
  Image,
  Text,
  Stack,
  useBreakpointValue,
  Button,
  Fade,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import kiidoLogo from "../assets/images/kiido.svg";
import Utils from "../services/Utils";

// Helper function to parse query parameters
const useQuery = () => new URLSearchParams(useLocation().search);

const ThankYou = () => {
  const [locale, setLocale] = useState("fr");
  const { t, i18n } = useTranslation();
  const query = useQuery();

  useEffect(() => {
    const savedLanguage = Cookies.get("preferred_language");
    const consent = Cookies.get("cookie_consent");
    if (savedLanguage && consent) {
      i18n.changeLanguage(savedLanguage);
    } else {
      i18n.changeLanguage("fr");
      if (consent) Cookies.set("preferred_language", "fr", { expires: 365 });
    }
  }, [i18n]);

  const name = query.get("name") || "N/A";
  const date = query.get("date") || "N/A";
  const timeSlot = query.get("timeslot") || "N/A";
  const serviceFr = query.get("service_fr") || "N/A";
  const serviceEn = query.get("service") || "N/A";
  const service = i18n.language === 'fr' ? serviceFr : serviceEn;
  const fileNumber = query.get("file_number") || "N/A";
  const email = query.get("email") || "N/A";
  const phone = query.get("phone") || "N/A";
  const association = query.get("association") || "N/A";

  let startTime = "N/A";
  let endTime = "N/A";

  if (timeSlot !== "N/A") {
    const times = timeSlot.split(" to ");
    if (times.length === 2) {
      startTime = times[0]; // First part (start time)
      endTime = times[1];   // Second part (end time)
    }
  }

  useEffect(() => {
    const localeFromQuery = query.get("locale");
    if (localeFromQuery) setLocale(localeFromQuery);
  }, [query]);

  useEffect(() => {
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
      const consent = Cookies.get("cookie_consent");
      if (consent) Cookies.set("preferred_language", lng, { expires: 365 });
    };
    if (locale) changeLanguage(locale);
  }, [locale, i18n]);

  const titleFontSize = useBreakpointValue({ base: "xl", md: "2xl" });
  const subtitleFontSize = useBreakpointValue({ base: "md", md: "lg" });

  const handleRedirect = () => {
    window.location.href = "https://kiido.fr/appointments";
  };

  useEffect(() => {

    // console.log("timeSlot", startTime, endTime);

  }, [])


  return (
    <Fade in>
      <Box
        as={motion.div}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        bg="white"
        borderRadius="lg"
        // boxShadow="lg"
        p={6}
        maxW="lg"
        mx="auto"
        mt={10}
        textAlign="center"
      >
        <Image src={kiidoLogo} alt="Kiido Logo" mb={4} mx="auto" />

        <Alert status="success" mb={4} borderRadius="md" flexDirection="column">
          {/* <AlertIcon /> */}
          <AlertTitle pb={1}>{t("content.confirmation.payment_success")}</AlertTitle>
          <AlertDescription>
            {t("content.confirmation.payment_reference")}: {fileNumber}
          </AlertDescription>
        </Alert>

        <Text fontSize={titleFontSize} fontWeight="bold" mb={2}>
          {t("content.confirmation.title_demo")}
        </Text>

        <Stack spacing={2} mt={4}>
          <Text fontWeight="bold" color="red.500" fontSize={subtitleFontSize}>
            {t("content.confirmation.name")}: {name}
          </Text>
          <Text fontWeight="bold" color="red.500" fontSize={subtitleFontSize}>
            {t("content.confirmation.date")}: {date}
          </Text>
          <Text fontWeight="bold" color="red.500" fontSize={subtitleFontSize}>
            {t("content.confirmation.timeslot")}: {Utils.convertUTCToLocalTimeZone(startTime) + ' - ' + Utils.convertUTCToLocalTimeZone(endTime)}
          </Text>
          <Text fontWeight="bold" color="red.500" fontSize={subtitleFontSize}>
            {t("content.confirmation.service")}: {service}
          </Text>
          <Text fontWeight="bold" color="red.500" fontSize={subtitleFontSize}>
            {t("content.confirmation.email")}: {email}
          </Text>
          <Text fontWeight="bold" color="red.500" fontSize={subtitleFontSize}>
            {t("content.confirmation.phone")}: {phone}
          </Text>
          <Text fontWeight="bold" color="red.500" fontSize={subtitleFontSize}>
            {t("content.confirmation.association")}: {association}
          </Text>
        </Stack>

        <Text fontSize="sm" color="gray.600" mt={4}>
          {t("content.confirmation.note")}
        </Text>

        <Button
          as={motion.button}
          mt={6}
          bg="#FF6666"
          color="white"
          _hover={{ bg: "#E55353" }}

          onClick={handleRedirect}
          minWidth="150px"
        >
          {t("content.confirmation.redirect_button")}
        </Button>
      </Box>
    </Fade>
  );
};

export default ThankYou;
